import { Avatar, Popover, Timeline } from 'antd'
import styles from './index.module.scss'
import { memo, ReactNode, useMemo } from 'react'
import { useTranslation } from '@/services/i18n'
import { AutoSweepAuditStatus, TxAuditStatusEnum, TxAuditStatusMap } from '@/constants/enum'
import logo from '@/assets/images/safeHeron.png'
import dayjs from 'dayjs'
import cls from 'classnames'
import { AuditInfoModel, AuditListModel } from '@/services/apis/policy/model'

interface ChildProp {
  flow: AuditInfoModel
  auditStatus: AutoSweepAuditStatus
  renderChildren: () => ReactNode
}
const Approval = memo<ChildProp>(prop => {
  const { t } = useTranslation()
  const { flow, renderChildren, auditStatus } = prop

  const filteredAuditList = useMemo(() => {
    let auditList = flow.auditList
    if (
      auditStatus === AutoSweepAuditStatus.PASSED ||
      auditStatus === AutoSweepAuditStatus.REJECT
    ) {
      const endIdx = flow.auditList.findLastIndex(audit => audit.auditType === auditStatus)
      if (endIdx > -1) {
        auditList = flow.auditList.slice(0, endIdx + 1)
      }
    }
    return auditList
  }, [flow, auditStatus])

  function statusMap(status: TxAuditStatusEnum) {
    return TxAuditStatusMap[status]
  }

  function timeFormat(time: number) {
    return dayjs(time).format('YYYY.MM.DD HH:mm:ss')
  }
  const createUser = (
    <div className={styles.singleUser}>
      <div className={styles.userStatus}>
        <Avatar size="default" src={flow?.initiatorUserPortrait || logo} />
        <div className={styles.user}>
          <div className={styles.boldText}>{t('record.createUser')}</div>
          <span>{flow.initiatorUserName}</span>
        </div>
      </div>
      <div>{timeFormat(flow.initiatorTime)}</div>
    </div>
  )

  const inapprvalUser: AuditListModel[] = []
  const apprvaledUser: AuditListModel[] = []

  filteredAuditList.forEach(user => {
    if (user.auditTime) {
      apprvaledUser.push(user)
    } else {
      inapprvalUser.push(user)
    }
  })

  const auditUser = [
    <div className={cls(styles.mutipleUser, styles['flow-color-1'])}>
      <div className={styles.boldText}>
        {t('autoSweep.decisionApproval')}({`${flow.thresholdM}/${flow.auditList.length}`})
      </div>
      <div className={styles.userList}>
        {apprvaledUser.map(item => {
          return (
            <div
              key={item.auditTime}
              className={cls([styles.userState, styles.flex1, styles.spaceBetween])}
            >
              <div className={styles.flex}>
                <Avatar size="default" src={item.auditUserPortrait} />
                <div className={styles.user}>
                  <div>
                    {item.auditUserName} {item.isDeleted && <span>({t('common.delete1')})</span>}
                  </div>
                  <span
                    className={cls({
                      [styles.pending]: item.auditType === TxAuditStatusEnum.NEW,
                      [styles.passed]: item.auditType === TxAuditStatusEnum.PASSED,
                      [styles.refused]: item.auditType === TxAuditStatusEnum.REFUSED,
                      [styles.boldText]: true,
                    })}
                  >
                    ({statusMap(item.auditType)})
                  </span>
                </div>
              </div>
              <span>{timeFormat(item.auditTime)}</span>
            </div>
          )
        })}
        <div className={cls([styles.flex, styles.flex1])}>
          {inapprvalUser.map(item => {
            return (
              <div key={item.auditTime} className={styles.userState}>
                <Avatar size="default" src={item.auditUserPortrait} />
                <div className={styles.user}>
                  <div>{item.auditUserName}</div>
                  <span className={styles.boldText}>({statusMap(item.auditType)})</span>
                </div>
              </div>
            )
          })}
        </div>
      </div>
    </div>,
  ]

  //  dot图标
  const dot = <div className={styles.dot}></div>
  const auditUserChildren = auditUser.map(children => {
    return {
      children,
      dot,
    }
  })
  const items = [
    {
      children: createUser,
      dot: dot,
    },
    ...auditUserChildren,
  ]
  return (
    <div className={styles.approveView}>
      <Popover
        placement="bottom"
        title={<div style={{ fontSize: '14px', color: '#888E8E' }}>{t('record.approval')}</div>}
        content={
          <div>
            <Timeline items={items} />
          </div>
        }
        trigger="hover"
        overlayInnerStyle={{ minWidth: 400, maxHeight: 500, overflowY: 'auto' }}
      >
        {renderChildren()}
      </Popover>
    </div>
  )
})
export default Approval
